import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-grid">
                    {/* Brand */}
                    <div className="footer-section">
                        <Link to="/" className="footer-logo">
                            <div className="logo-icon">
                                <img src="/logo/agroov-icone-novo.png" alt="Agroov" style={{ width: '180px', height: 'auto', objectFit: 'contain', marginLeft: '-15px' }} />
                            </div>
                        </Link>
                        <p className="footer-desc">
                            Conectando vendedores, compradores e transportadores com transparência.
                        </p>
                    </div>

                    {/* Links */}
                    <div className="footer-section">
                        <h4>Navegação</h4>
                        <nav className="footer-nav">
                            <Link to="/">Início</Link>
                            <Link to="/anuncios">Anúncios</Link>
                            <Link to="/ajuda">Ajuda</Link>
                            <Link to="/login">Entrar</Link>
                            <Link to="/cadastro">Cadastrar</Link>
                        </nav>
                    </div>

                    {/* Categorias */}
                    <div className="footer-section">
                        <h4>Categorias</h4>
                        <nav className="footer-nav">
                            <Link to="/anuncios?categoria=Bovino">Bovinos</Link>
                            <Link to="/anuncios?categoria=Equino">Equinos</Link>
                            <Link to="/anuncios?categoria=Suíno">Suínos</Link>
                            <Link to="/anuncios?categoria=Ovino">Ovinos</Link>
                            <Link to="/anuncios?categoria=Aves">Aves</Link>
                            <Link to="/anuncios?categoria=Outros">Outros</Link>
                        </nav>
                    </div>

                    {/* Contato */}
                    <div className="footer-section">
                        <h4>Contato</h4>
                        <div className="footer-contact">
                            <div className="contact-item">
                                <span className="contact-icon" style={{ display: 'flex', alignItems: 'center' }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                </span>
                                <a href="mailto:agroov2026@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>agroov2026@gmail.com</a>
                            </div>
                            <div className="contact-item">
                                <span className="contact-icon" style={{ display: 'flex', alignItems: 'center' }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
                                    </svg>
                                </span>
                                <a href="https://wa.me/5531996205443" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>(31) 99620-5443</a>
                            </div>
                            <div className="contact-item">
                                <span className="contact-icon" style={{ display: 'flex', alignItems: 'center' }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                                </span>
                                <a href="https://instagram.com/agroovbr" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>@agroovbr</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2026 Agroov (v2). Todos os direitos reservados.</p>
                    <div className="footer-legal">
                        <Link to="/termos-de-uso">Termos de Uso</Link>
                        <Link to="/politica-de-privacidade">Política de Privacidade</Link>
                        <Link to="/lgpd">LGPD</Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
